import React, {useState} from "react";
import PropTypes from "prop-types";
import {
  AAccordion,
  AAccordionBody,
  AAccordionHeader,
  AAccordionHeaderTitle,
  AAccordionPanel,
  ACol,
  AContainer,
  ARow
} from "@cisco-sbg-ui/magna-react";
import {useSelector} from "react-redux";
import MarkdownEditor from "components/MarkdownEditor";
import TooltipDelay from "components/TooltipDelay";
import useDrawer from "hooks/useDrawer";
import {selectIncidentPlaybookStages} from "store/selectors";
import PlaybookTaskButton from "./PlaybookTaskButton";
import SelectEntityDrawer from "./SelectEntityDrawer";
import css from "./PlaybookStage.module.scss";

export default function PlaybookStage({activeStage}) {
  const stages = useSelector(selectIncidentPlaybookStages);
  const [coaId, setCoaId] = useState("");
  const [coaTargetType, setCoaTargetType] = useState("");
  const [workflowId, setWorkflowId] = useState("");
  const stage = stages[activeStage - 1]?.coa?.stage;
  const {
    close: closeDrawer,
    open: openDrawer,
    isOpen: isDrawerOpen
  } = useDrawer();

  return (
    <div className={css.content}>
      <AAccordion className={css.stage}>
        {stages[activeStage - 1]?.tasks.map(({coa}, index) => (
          <AAccordionPanel key={`${coa.title}-${index}`}>
            <AAccordionHeader
              className={`flex-row-reverse ${css.accordionHeader}`}>
              <AAccordionHeaderTitle>
                <AContainer fluid className="pa-0">
                  <ARow
                    noGutters
                    className="align-end justify-space-between flex-nowrap">
                    <ACol cols="auto" className={css.titleCol}>
                      <a className="mr-1">{coa.title}</a>
                    </ACol>
                    <ACol cols="auto">
                      <PlaybookTaskButton
                        {...{
                          coa,
                          openDrawer,
                          setCoaId,
                          setCoaTargetType,
                          setWorkflowId,
                          stage
                        }}
                      />
                    </ACol>
                  </ARow>
                  <ARow noGutters>
                    <ACol cols="12">
                      <TooltipDelay
                        placement="bottom-left"
                        title={coa.short_description}>
                        <div className={css.shortDescription}>
                          {coa.short_description}
                        </div>
                      </TooltipDelay>
                    </ACol>
                  </ARow>
                </AContainer>
              </AAccordionHeaderTitle>
            </AAccordionHeader>
            <AAccordionBody className="pl-5 pr-0">
              <AContainer fluid className="pa-0 mb-2 mt-1">
                <ARow noGutters className="justify-space-between align-center">
                  <ACol cols="12">
                    <MarkdownEditor
                      active={false}
                      minPreviewHeight={10}
                      value={coa.description}
                    />
                  </ACol>
                </ARow>
              </AContainer>
            </AAccordionBody>
          </AAccordionPanel>
        ))}
      </AAccordion>
      <SelectEntityDrawer
        {...{coaId, coaTargetType, closeDrawer, isDrawerOpen, workflowId}}
      />
    </div>
  );
}

PlaybookStage.propTypes = {
  /**
   * Active playbook stage the user is viewing
   */
  activeStage: PropTypes.number
};
